"use client";
import React, { useEffect, useState } from 'react';
import './Step1.css';
import PropTypes from 'prop-types';
import useSiniestrosStore from '../../../store/siniestrosStore';
import { getToken, removeToken, removeValidateType } from '../../../utils/claimManager';
import { Loader, SpanError } from '../../../components';
import { Select, Button, Input } from 'atm-global-stylish/dist';
import { useNavigate } from 'react-router-dom';
import { isEmpty } from '../../../utils/functions';
import { INPUT_CLASSNAME, SELECT_CLASSNAME } from '../../../config/constants';

const Step1 = ({ avanzar, retroceder, formData, config, loader, setFormData, instance, getInstance, clearInstance }) => {
	const {
		loading,
	} = useSiniestrosStore();
	const navigation = useNavigate();

	const options = [
		{ value: "", title: "El vehiculo asegurado de ATM es*" },
		...Object.entries(config?.insured_vehicle_type || {}).map(([key, value]) => ({
			value: key,
			title: value
		}))
	];
	const [errors, setErrors] = useState({});
	const [arrayErrors, setArrayErrors] = useState([]);

	useEffect(() => {
		const token = getToken();
		if (!token) {
			navigation('/');
			clearInstance();
		} else {
			getInstance(token);
			if (instance?.things) {
				navigation('/');
			}
		}
	}, [])

	useEffect(() => {
		if (instance) {
			if (instance.sinister_type) setFormData({ ...formData, branch: instance.sinister_type });
			if (instance.insured_plate) setFormData({ ...formData, plate: instance.insured_plate });
			if (instance.insured_dni) setFormData({ ...formData, dni: instance.insured_dni });
			if (instance.insured_policy) setFormData({ ...formData, policy: instance.insured_policy });
		}
	}, [instance]);

	const validate = () => {
		const newErrors = {};
		let arrayErrorsAux = [];

		if (!formData.plate && !formData.dni && !formData.policy) newErrors.data = true;
		if (!formData.branch) newErrors.sinister_type = true;

		if (isEmpty(formData.branch)) {
			arrayErrorsAux['branch'] = 'Debe ingresar un tipo de vehículo válido';
		}

		if (isEmpty(formData.plate) && isEmpty(formData.dni) && isEmpty(formData.policy)) {
			arrayErrorsAux['data'] = 'Debe ingresar al menos la patente, el DNI o el número de póliza para continuar';
		}

		let responseValidationLicense = true;
		if ([3, 4].includes(parseInt(formData.branch))) {
			if (!isEmpty(formData.plate))
				responseValidationLicense = validateLicence(formData.plate, formData.branch);
		}

		if (responseValidationLicense === false) {
			newErrors.plate = true;
		}

		setArrayErrors(arrayErrorsAux);
		setErrors(newErrors);
		return Object.keys(newErrors).length === 0;
	}

	const handleContinue = () => {
		if (!validate()) return;
		avanzar();
	}

	const handleBack = () => {
		setFormData({
			branch: "",
			dni: "",
			policy: "",
			plate: "",
			sinister_date: "",
			sinister_number: ""
		})
		removeToken();
		removeValidateType();
		// const token = getToken();
		// if(!token) {
		retroceder(0);
		// }
	}

	const validateLicence = (license, branch) => {
		const motorcycleOld = /^[0-9]{3}[a-zA-Z]{3}$/;
		const motorcycleNew = /^[a-zA-Z]{1}[0-9]{3}[a-zA-Z]{3}$/;
		const carOld = /^[a-zA-Z]{3}[0-9]{3}$/;
		const carNew = /^[a-zA-Z]{2}[0-9]{3}[a-zA-Z]{2}$/;

		if (license === 'A DECLARAR') return true;

		switch (parseInt(branch)) {
			case 3: return carOld.test(license) || carNew.test(license);
			case 4: return motorcycleOld.test(license) || motorcycleNew.test(license);
			default: return false;
		}
	};

	if (loading || loader) return <Loader />;

	return (
		<div className='step1 md:w-8/12 m-auto my-8 px-5 md:px-0'>
			<div className='flex w-full m-auto flex-col gap-6 mt-12'>
				<div className='flex flex-row mx-auto justify-between w-full lg:w-1/2 mb-5'>
					<div className="flex flex-col w-full">
						<Select
							onChange={(e) => { setArrayErrors((prev) => ({ ...prev, branch: null })); setFormData(prev => ({ ...prev, branch: e.target.value })) }}
							selectedValue={formData.branch}
							list={options}
							className={`${SELECT_CLASSNAME} text-grey-tx`}
						/>
						{
							arrayErrors?.branch && (<SpanError text={arrayErrors.branch} />)
						}
					</div>
				</div>
				<p className='text-base md:text-xl text-red font-semibold text-center md:mt-12 md:my-5'>Para validar los datos nuestro asegurado ingresa al menos uno de los siguientes datos</p>
				<div className="flex flex-col">
					<div className='grid grid-cols-1 md:grid-cols-3 gap-y-3 md:gap-4 md:gap-y-0 w-full'>
						<div className="flex flex-col w-full">
							<Input
								className={`${INPUT_CLASSNAME} uppercase`}
								type='text'
								value={formData.plate}
								handleChange={(e) => {
									setArrayErrors((prev) => ({ ...prev, data: null }));
									setFormData(prev => ({ ...prev, plate: e.target.value.toUpperCase() }));
								}}
								placeholder='PATENTE'
								maxLength={7}
								regex={/^[a-zA-Z0-9]*$/}
							/>
							{
								errors?.plate === true ?
									<p className='text-shiny-pink font-normal text-sm md:mt-2'>Debe ingresar una patente válida.</p>
									:
									<></>
							}
						</div>
						<div className="flex flex-col w-full">
							<Input
								className={INPUT_CLASSNAME}
								type='number'
								value={formData.dni}
								handleChange={(e) => {
									setArrayErrors((prev) => ({ ...prev, data: null }));

									const onlyNumbers = e.target.value.replace(/\D/g, '');

									if (onlyNumbers.length <= 8)
										setFormData(prev => ({ ...prev, dni: onlyNumbers }));
									else
										return
								}}
								placeholder='DNI'
								maxLength={8}
							/>
						</div>
						<div className="flex flex-col w-full">
							<Input
								className={INPUT_CLASSNAME}
								type='number'
								value={formData.policy}
								handleChange={(e) => {
									setArrayErrors((prev) => ({ ...prev, data: null }));

									const onlyNumbers = e.target.value.replace(/\D/g, '');

									if (onlyNumbers.length <= 8)
										setFormData(prev => ({ ...prev, policy: onlyNumbers }));
									else
										return
								}}
								placeholder='NUMERO DE POLIZA'
								maxLength={8}
							/>
						</div>
					</div>
					{
						arrayErrors?.data && (<SpanError text={arrayErrors.data} className='text-pink text-sm mt-2 text-center' />)
					}
				</div>
				{Object.keys(errors).length > 0 && (
					<p className="text-pink text-sm text-center mb-4">(*) Los campos marcados son obligatorios.</p>
				)}
				<div className='flex flex-col-reverse md:flex-row w-full justify-between gap-2 md:gap-7 mt-5 md:mt-10 px-5 md:px-0'>
					<Button handleClick={handleBack} type='secondary' className='p-2 md:p-3' title='Volver al paso anterior' />
					<Button handleClick={handleContinue} type='primary' className='p-2 md:p-3' title='Continuar' />
				</div>
			</div>

		</div>
	);
};

Step1.propTypes = {
	avanzar: PropTypes.func.isRequired,
	retroceder: PropTypes.func.isRequired,
	formData: PropTypes.object.isRequired,
	config: PropTypes.object.isRequired,
	loader: PropTypes.bool.isRequired,
	setFormData: PropTypes.func.isRequired,
	fetchSinisterData: PropTypes.func.isRequired,
};

export default Step1;